export default __webpack_public_path__ + "static/media/Group9223.96088b6b.svg";